import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ExaminationModal } from '@/components/modules/Modal/ExaminationModal';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { HotlineProDataList } from '@/feature/hotline/professional/list/component/HotlineProDataList';
import { hotlineProListViewStyle } from '@/feature/hotline/professional/list/page/style';
import { pagePath } from '@/utils/router/pagePath';
/** パンくずリスト */
export const breadcrumbs = [
    {
        link: pagePath.mypage.professional.index(),
        text: 'マイページ',
    },
    { text: '匿名ホットライン相談一覧' },
];
/**
 * 匿名コンサルホットライン 相談一覧（View 部分のみ）
 * @description View 全体の表示, api 取得データを表示用に変換して渡す
 */
export const HotlineProListView = (props) => {
    const { canUseHotline = true, isLoading, list } = props;
    const style = hotlineProListViewStyle();
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(BandHead, Object.assign({ bgColor: 'gradientDarkGreen', className: style.title(), tagName: 'h1' }, { children: _jsx("span", Object.assign({ className: style.titleInner() }, { children: "\u533F\u540D\u30DB\u30C3\u30C8\u30E9\u30A4\u30F3\u76F8\u8AC7\u4E00\u89A7" })) })), _jsx("div", Object.assign({ className: style.content() }, { children: _jsx(HotlineProDataList, { isLoading: isLoading, list: list }) })), !canUseHotline && _jsx(ExaminationModal, { isShow: true })] }));
};
